import React, { FC, forwardRef, useEffect, useRef, useState } from "react";
import classes from "./ShortzVideoPlayer.module.css";
import ReactPlayer from "react-player";
import { motion, useInView } from "framer-motion";
import debounce from "lodash/debounce";
import { useLocation, useNavigate } from "react-router-dom";

type ShortzProps = {
  item: any;
  idx: number;
  rootRef?: any;
};

const ShortzVideoPlayer: FC<ShortzProps> = forwardRef(
  ({ item, idx }, rootRef: any) => {
    const playerRef = useRef<any>(null);

    const [playing, setPlaying] = useState(false);

    const isInView = useInView(playerRef, {
      once: false,
      amount: 0.5,
      root: rootRef,
    });

    useEffect(() => {
      if (isInView) {
        setPlaying(true);
      } else {
        setPlaying(false);
      }

      return () => {
        setPlaying(false);
      };
    }, [isInView, playerRef]);

    // useEffect(() => {
    //   // Create a debounced version of the setPlaying function
    //   const handleSetPlaying = debounce(() => {
    //     if (isInView) {
    //       setPlaying(true);
    //     } else {
    //       setPlaying(false);
    //     }
    //   }, 100); // Adjust the debounce delay as necessary

    //   // Call the debounced function
    //   handleSetPlaying();

    //   // Cleanup: cancel debounce on unmount or when dependencies change
    //   return () => {
    //     handleSetPlaying.cancel();
    //     setPlaying(false); // Ensure the video is paused when unmounted
    //   };
    // }, [isInView, playerRef]);

    // const navigate = useNavigate();

    // const location = useLocation();

    // const [key, setKey] = useState<any>("");

    // useEffect(() => {
    //   const queryParams = new URLSearchParams(location.search);
    //   const keyParam = queryParams.get("key");
    //   setKey(keyParam);
    // }, [location]);

    // useEffect(() => {
    //   const observer = new IntersectionObserver(
    //     (entries) => {
    //       if (entries[0].isIntersecting) {
    //         const id = entries[0].target.id;

    //         const params = new URLSearchParams(location.search);
    //         params.set("key", id);

    //         navigate(`${location.pathname}?${params.toString()}`, {
    //           replace: true,
    //         });
    //       }
    //     },
    //     {
    //       threshold: 0.5,
    //     }
    //   );

    //   if (playerRef.current) {
    //     observer.observe(playerRef.current);
    //   }

    //   return () => {
    //     if (playerRef.current) {
    //       observer.unobserve(playerRef.current);
    //     }
    //   };
    // }, [key]);


    return (
      <motion.div
        className={classes.shortz_container}
        key={idx}
        ref={playerRef}
        id={`${item?.key}`}
      >
        <motion.div
          className={classes.shortz_loading}
          initial={{
            background:
              "linear-gradient(45deg,hsl(0deg 0% 14%) 0%,hsl(0deg 0% 14%) 20%,hsl(0deg 0% 14%) 29%,hsl(0deg 0% 14%) 36%,hsl(0deg 0% 14%) 43%,hsl(0deg 0% 14%) 50%,hsl(228deg 3% 12%) 57%,hsl(228deg 5% 11%) 64%,hsl(228deg 8% 9%) 71%,hsl(228deg 11% 8%) 80%,hsl(228deg 14% 7%) 100%)",
          }}
          animate={{
            background: [
              "linear-gradient(45deg, hsl(228deg 14% 7%) 0%, hsl(228deg 11% 8%) 20%, hsl(228deg 8% 9%) 29%, hsl(228deg 5% 11%) 36%, hsl(228deg 3% 12%) 43%, hsl(0deg 0% 14%) 50%, hsl(228deg 3% 12%) 57%, hsl(228deg 5% 11%) 64%, hsl(228deg 8% 9%) 71%, hsl(228deg 11% 8%) 80%, hsl(228deg 14% 7%) 100%)",
              "linear-gradient(45deg,hsl(0deg 0% 14%) 0%,hsl(0deg 0% 14%) 20%,hsl(0deg 0% 14%) 29%,hsl(0deg 0% 14%) 36%,hsl(0deg 0% 14%) 43%,hsl(0deg 0% 14%) 50%,hsl(228deg 3% 12%) 57%,hsl(228deg 5% 11%) 64%,hsl(228deg 8% 9%) 71%,hsl(228deg 11% 8%) 80%,hsl(228deg 14% 7%) 100%)",
              "linear-gradient(45deg,hsl(228deg 14% 7%) 0%,hsl(228deg 11% 8%) 20%,hsl(228deg 8% 9%) 29%,hsl(228deg 5% 11%) 36%,hsl(228deg 3% 12%) 43%,hsl(0deg 0% 14%) 50%,hsl(0deg 0% 14%) 57%,hsl(0deg 0% 14%) 64%,hsl(0deg 0% 14%) 71%,hsl(0deg 0% 14%) 80%,hsl(0deg 0% 14%) 100%)",
            ],
          }}
          transition={{
            duration: 2,
            repeatType: "mirror",
            repeat: Infinity,
            ease: "linear",
          }}
        ></motion.div>
        <ReactPlayer
          url={`https://www.youtube.com/watch?v=${item?.key}`}
          controls={true}
          playing={playing}
          loop={false}
          muted={false}
          playsinline={true}
          width="100%"
          className={classes.shortz}
        />
      </motion.div>
    );
  }
);

export default ShortzVideoPlayer;
